export default {
    path : "warehouse-item-all",
    name : "warehouse-item-all",
    meta : {
        title : "全部项目"
    },
    component: () => import('@/pages/warehouse/all/Index'),
    redirect: {
        name : "warehouse-item-all-whole"
    },
    children: [
        {
            path: 'all',
            name: 'warehouse-item-all-whole',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'warehouse-item-all-recent',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'warehouse-item-all-atme',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'warehouse-item-all-meat',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'warehouse-item-all-reply',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'warehouse-item-all-search',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path : 'detail/:id',
            name : 'warehouse-item-all-detail',
            metal: {
                title : '项目详细信息',
            },
            component: () => import('@/pages/itemCommon/Detail'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/warehouse/allitem/index.js